/** @type {import('../help-index.js').HelpScreen} */
export const MET_TER_HELP = {
  screenId: 'met-ter',
  label: 'Terminales de Ventas',
  navPath: 'Métricas → Terminales de Ventas',
  keywords: ['ventas del día', 'terminal', 'pos', 'cobros por medio de pago'].map((k) => k.toLowerCase()),
  status: 'draft',
  summary: 'Ventas y cobros del día por terminal: totales, medios de pago y artículos más vendidos.',
  sidebarItems: [{
    id: 'terminal',
    screenId: 'met-ter',
    label: 'Informe por terminal',
    description: 'Métricas de una terminal en el período.',
    detail: {
      sections: [
        {
          title: 'Para qué sirve',
          intro: 'Controlás el desempeño de cada terminal de ventas (POS): facturación, cobranzas y productos.',
        },
        {
          title: 'Paso 1 — Elegir terminal y período',
          fields: [
            { label: 'Terminal', description: 'Lista de terminales activas. Obligatorio.' },
            { label: 'Período', description: 'Hoy, semana, mes, mes anterior o personalizado.' },
          ],
        },
        {
          title: 'Paso 2 — Leer el informe',
          bullets: [
            'Totales de ventas por moneda.',
            'Gráfico de cobros por medio de pago (efectivo, tarjeta, etc.).',
            'Ranking de artículos vendidos por cantidad.',
          ],
        },
      ],
    },
  }],
}
